const getDeepEqual = (a, b) => {
  if (Object.is(a, b)) return true;
  if (a === null || b === null) return false;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let index = 0; index < a.length; index += 1) {
      if (!getDeepEqual(a[index], b[index])) return false;
    }
    return true;
  }

  if (typeof a === "object" && typeof b === "object") {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;

    for (const key of aKeys) {
      if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
      if (!getDeepEqual(a[key], b[key])) return false;
    }
    return true;
  }

  return false;
};

export default getDeepEqual;
